import { GALLERY } from "@/data";
import { Reveal } from "@/components/Reveal";

export const Realizations = () => {
  return (
    <section id="realizacje" className="bg-white py-24 sm:py-32" data-testid="realizations-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <Reveal>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-magenta">
              Realizacje
            </span>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="mt-4 font-heading font-bold text-navy text-3xl sm:text-4xl lg:text-5xl tracking-tight">
              Jakość widoczna w każdym detalu
            </h2>
          </Reveal>
          <Reveal delay={140}>
            <p className="mt-6 text-base sm:text-lg text-zinc-600 leading-relaxed">
              Rozdzielnice, okablowanie strukturalne, monitoring i instalacje Smart Home –
              wykonane zgodnie ze sztuką i normami.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          {GALLERY.map((src, i) => (
            <Reveal
              key={src}
              delay={(i % 3) * 90}
              className={i % 5 === 0 ? "col-span-2 lg:col-span-2" : ""}
            >
              <div className="group relative overflow-hidden bg-zinc-100 aspect-[4/3]" data-testid={`gallery-item-${i}`}>
                <img
                  src={src}
                  alt={`Realizacja NDNS Elektro – instalacje elektryczne i słaboprądowe ${i + 1}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 ring-0 ring-magenta group-hover:ring-4 ring-inset transition-all duration-300" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
